var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMypacomefavicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 595.28 595.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #faba79;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2155.5,
    y1: 237.47,
    x2: 1896.51,
    y2: 237.47,
    gradientTransform: "translate(0 595.28) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003a54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#02405c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#044663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003a54"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 297.64,
    cy: 297.64,
    r: 297.64
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "321.54 90.47 187.16 46.84 187.16 150.97 321.54 107.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "274.24 107.35 408.62 150.97 408.62 46.84 274.24 90.47"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 298.64,
    cy: 177.71,
    r: 21.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m436.87,211.31c-13.04-13.04-27.91-24.07-44.63-32.76-5.52-3.01-11.37-5.68-17.22-8.19-2.84-1.17-5.85-2.01-8.69-3.18l-69.2,149.26-68.36-149.26c-2.84,1-5.68,1.84-8.52,3.01-6.02,2.51-11.87,5.18-17.38,8.19-16.55,8.86-31.42,19.72-44.46,32.76-17.38,17.38-31.09,38.11-40.95,62.01-9.86,23.9-14.88,50.14-14.88,78.72s5.01,54.82,14.88,78.72c9.86,23.9,23.57,44.63,40.95,62.01,17.38,17.38,38.11,31.09,61.84,40.95s49.64,14.88,77.39,14.88,53.65-5.01,77.39-14.88,44.46-23.57,61.84-40.95c17.38-17.38,31.09-38.11,40.95-62.01,9.86-23.9,14.88-50.14,14.88-78.72s-5.01-54.82-14.88-78.72c-9.86-23.9-23.57-44.63-40.95-62.01v.17Zm7.69,205.92c-8.19,19.72-18.89,36.1-33.09,50.31-14.04,14.04-30.92,25.24-50.14,33.09-19.22,8.02-40.78,12.03-63.68,12.03s-44.29-4.01-63.68-12.03c-19.22-8.02-36.1-19.05-50.14-33.09-14.21-14.21-25.07-30.75-33.09-50.31s-12.03-41.45-12.03-65.02,4.01-45.63,12.03-65.02c8.02-19.39,19.22-36.44,33.09-50.31,9.36-9.36,20.22-17.38,31.92-24.07l81.4,169.15,82.23-169.31c11.87,6.69,22.73,14.71,32.26,24.24,14.04,14.04,25.07,30.92,33.09,50.31,8.02,19.56,12.03,41.45,12.03,65.02s-4.01,45.63-12.03,65.02h-.17Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypacomefavicon);
export default __webpack_public_path__ + "static/media/mypacomefavicon.330dc2bb96b9cfcbc658daaeb317600d.svg";
export { ForwardRef as ReactComponent };